import React from 'react';
import { Space, Tag, Typography } from 'antd';
import NextActions from './NextActions';
import SourceLimitation from './SourceLimitation';
import CitationList from './CitationList';
import { confidenceColor } from '../utils/formatters';

const { Text, Paragraph } = Typography;

export default function SubAnswerList({ subAnswers = [] }) {
  return (
    <Space direction="vertical" size={14} style={{ width: '100%' }}>
      {subAnswers.map((subAnswer, index) => (
        <div
          key={`${subAnswer.question || 'question'}-${index}`}
          style={{
            borderTop: index === 0 ? 'none' : '1px solid #e4e7ec',
            paddingTop: index === 0 ? 0 : 12,
          }}
        >
          <Space size={8} align="start" style={{ marginBottom: 6 }}>
            <Text strong>
              {index + 1}. {subAnswer.question}
            </Text>
            {subAnswer.confidence ? (
              <Tag color={confidenceColor(subAnswer.confidence)} style={{ marginInlineEnd: 0 }}>
                {subAnswer.confidence}
              </Tag>
            ) : null}
            {subAnswer.answerable === false ? (
              <Tag color="red" style={{ marginInlineEnd: 0 }}>
                Source limited
              </Tag>
            ) : null}
          </Space>
          <Paragraph className="glp1-answer-text">{subAnswer.answer}</Paragraph>
          <NextActions actions={subAnswer.next_actions} />
          <SourceLimitation limitations={subAnswer.answerable === false ? subAnswer.limitations : []} />
          <CitationList citations={subAnswer.citations} />
        </div>
      ))}
    </Space>
  );
}
